import { dataProps, 
        variantListProps, 
        logProps, 
        imageListProps, 
        estoreDownloadable, 
        estorePriceVariation, 
        estorePriceVariationSource, 
        otherVariantListProps } from './properties'

export const setInventoryMasterList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setInventoryMasterAutocompleteList = (state, payload) => {
    state.autocomplete_list = payload
}

export const resetInventoryMasterAutocompleteList = (state, payload) => {
    state.autocomplete_list = payload
}

export const toggleInventoryMasterLoadingState = (state, payload) => {
    state.loading = payload
}

export const setInventoryMasterData = (state, payload) => {
    state.props = payload.response
    state.statement.list = []
    if(state.props.variant_list.length === 0) {
        state.props.variant_list = [JSON.parse(JSON.stringify(variantListProps))]
    } else if(payload.copy) {
        state.props.variant_list.forEach(element => {
            element.id = 0
        })
    }
    
    if(state.props.other_variations.length === 0) {
        state.props.other_variations = [JSON.parse(JSON.stringify(otherVariantListProps))]
    }

    if(state.props.estore_downloable.length === 0) {
        state.props.estore_downloable = [JSON.parse(JSON.stringify(estoreDownloadable))]
    } else if(payload.copy) {
        state.props.estore_downloable.forEach(element => {
            element.id = 0
        })
    }
    if(state.props.estore_price_variation.length === 0) {
        state.props.estore_price_variation = [JSON.parse(JSON.stringify(estorePriceVariation))]
    } else if(payload.copy) {
        state.props.estore_price_variation.forEach(element => {
            element.id = 0
        })
    }
    
    let key = 0
    state.props.variant_list.forEach(element => {
        element.key = key
        key ++
    })

    if(state.props.image_list.length === 0) {
        state.props.image_list = [JSON.parse(JSON.stringify(imageListProps))]
    } else if(payload.copy) {
        state.props.image_list.forEach(element => {
            element.id = 0
        })
    }

    key = 0
    state.props.image_list.forEach(element => {
        element.key = key
        key ++
    })

} 

export const addInventoryMasterDownloadable = state => {

    let key = 0
    state.props.estore_downloable.push(JSON.parse(JSON.stringify(estoreDownloadable)))

    state.props.estore_downloable.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeInventoryMasterDownloadable = (state, payload) => {

    let key = 0
    state.props.estore_downloable.splice(payload, 1)

    if(state.props.estore_downloable.length === 0) {
        state.props.estore_downloable = [JSON.parse(JSON.stringify(estoreDownloadable))]
    }

    state.props.estore_downloable.forEach(element => {
        element.key = key
        key ++
    })

}


export const addInventoryMasterPriceVariation = state => {

    let key = 0
    state.props.estore_price_variation.push(JSON.parse(JSON.stringify(estorePriceVariation)))

    state.props.estore_price_variation.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeInventoryMasterPriceVariation = (state, payload) => {

    let key = 0
    state.props.estore_price_variation.splice(payload, 1)

    if(state.props.estore_price_variation.length === 0) {
        state.props.estore_price_variation = [JSON.parse(JSON.stringify(estorePriceVariation))]
    }

    state.props.estore_price_variation.forEach(element => {
        element.key = key
        key ++
    })

}

export const addInventoryMasterPriceVariation_SubList = (state, payload) => {

    let key = 0
    state.props.estore_price_variation[payload].variation_source.push(JSON.parse(JSON.stringify(estorePriceVariationSource)))

    state.props.estore_price_variation[payload].variation_source.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeInventoryMasterPriceVariation_SubList = (state, payload) => {

    let key = 0
    state.props.estore_price_variation[payload.parent_key].variation_source.splice(payload.key, 1)

    if(state.props.estore_price_variation[payload.parent_key].variation_source.length === 0) {
        state.props.estore_price_variation[payload.parent_key].variation_source = [JSON.parse(JSON.stringify(estorePriceVariationSource))]
    }

    state.props.estore_price_variation[payload.parent_key].variation_source.forEach(element => {
        element.key = key
        key ++
    })

}

export const addNewInventoryMasterVariantListRow = state => {

    let key = 0
    state.props.variant_list.push(JSON.parse(JSON.stringify(variantListProps)))

    state.props.variant_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('variant_sub_item_id_'+(key-1)).focus()
    }, 300);

}

export const removeInventoryMasterVariantListRow = (state, payload) => {

    let key = 0

    state.props.variant_list.splice(payload, 1)

    if(state.props.variant_list.length === 0) {
        state.props.variant_list = [JSON.parse(JSON.stringify(variantListProps))]
    }

    state.props.variant_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const addNewInventoryMasterOtherVariantListRow = state => {

    let key = 0
    state.props.other_variations.push(JSON.parse(JSON.stringify(otherVariantListProps)))

    state.props.other_variations.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeInventoryMasterOtherVariantListRow = (state, payload) => {

    let key = 0

    state.props.other_variations.splice(payload, 1)

    if(state.props.other_variations.length === 0) {
        state.props.other_variations = [JSON.parse(JSON.stringify(otherVariantListProps))]
    }

    state.props.other_variations.forEach(element => {
        element.key = key
        key ++
    })

}

export const addNewAssetServiceLogRow = state => {

    let key = 0
    state.props.log_list.push(JSON.parse(JSON.stringify(logProps)))

    state.props.log_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeNewAssetServiceLogRow = (state, payload) => {

    let key = 0

    state.props.log_list.splice(payload, 1)

    if(state.props.log_list.length === 0) {
        state.props.log_list = [JSON.parse(JSON.stringify(logProps))]
    }

    state.props.log_list.forEach(element => {
        element.key = key
        key ++
    })

}

// IMAGE PROPS //
export const addNewInventoryMasterImageRow = state => {

    let key = 0
    state.props.image_list.push(JSON.parse(JSON.stringify(imageListProps)))

    state.props.image_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeInventoryMasterImageRow = (state, payload) => {

    let key = 0

    state.props.delete_image_list.push(state.props.image_list[payload])

    state.props.image_list.splice(payload, 1)

    if(state.props.image_list.length === 0) {
        state.props.image_list = [JSON.parse(JSON.stringify(imageListProps))]
    }

    state.props.image_list.forEach(element => {
        element.key = key
        key ++
    })

}
// END //

export const setItemStockCheckList = (state, payload) => {
    state.stock_list = payload
}

export const resetInventoryMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}

export const setInventoryMasterStatementList = (state, payload) => {
    state.statement.list = payload
}

export const setImportInventoryDiscountData = (state, payload) => {
    state.import_inventory_discount = payload
}

export const resetImportInventoryDiscountData = (state, payload) => {
    state.import_inventory_discount = []
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryMaster/mutations.js